import { type Car } from '@prisma/client'
import { Separator } from '#app/shared/ui/data-display/Separator.js'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import DetailsRow from './detailsRow'

type Props = {
  id: string
  car: Car
}

export default function Specifications({ id, car }: Props) {
  return (
    <div className="bg-white" id={id}>
      <Spacer size="48px" sizeMd="72px" />
      <p
        className={`
          ml-4 text-h4 text-neutral-900

          lg:ml-7
        `}
      >
        Especificaciones
      </p>
      <Spacer size="24px" />
      <div
        className={`
          px-4

          sm:px-0
        `}
      >
        <Separator className={`h-[2px] bg-neutral-75`} />
      </div>
      <DetailsRow car={car as any} />
    </div>
  )
}
